export default __webpack_public_path__ + "static/media/b57.ceb94100.png";